import { render, staticRenderFns } from "./OsList.vue?vue&type=template&id=16e9ea38&"
import script from "./OsList.vue?vue&type=script&lang=js&"
export * from "./OsList.vue?vue&type=script&lang=js&"
import style0 from "./OsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports